// extracted by mini-css-extract-plugin
export default {"visitsSummaryContainer":"VisitsSummary_visitsSummaryContainer__25l79","headerContainer":"VisitsSummary_headerContainer__sjCT4"};